import { configureStore } from '@reduxjs/toolkit'
import appReducer from './features/app/appSlice.js'
import mapReducer from "./features/map/mapSlice.js"
import potreeReducer from "./features/potree/potreeSlice.js"
import dropdownReducer from "./features/dropdown/dropdownSlice.js"

const store = configureStore({
  reducer: {
    app: appReducer,
    map: mapReducer,
    potree: potreeReducer,
    dropdown: dropdownReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware(),
})

export type IRootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
